// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"TextArea_textAreaContainer__TONXi"};